import * as React from "react";
import {connect} from "react-redux";
import Utils from "../../../Utils";
import InputUtils from "../../../InputUtils";

export enum NumberType {
    INT,
    DECIMAL
}

interface State {
    value: string;
    regex: any;
}
interface Props {
    value: string;
    onChange(value: any): void;
    classNameStyle: string;
    handleNegativeNumbers?: boolean;
    type?: NumberType;
    locale: {value: string, label: string};
}

const NEGATIVE_NUMBER_PREFIX = '-';
const DEFAULT_NUMBER_TYPE = NumberType.INT;

class NumberInput extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            value: "",
            regex: this.getAppropriateRegex(props.type)
        };
    }

    componentWillReceiveProps(props) {
        if (props.value) {
            this.setState({
                value: this.formatNumber(props.value)
            })
        }
    }

    getAppropriateRegex = (type: NumberType) => {
        if (!type) {
            type = DEFAULT_NUMBER_TYPE;
        }
        switch (type) {
            case NumberType.INT:
                return InputUtils.getIntNumberValidationRegex(this.props.locale.value);
            case NumberType.DECIMAL:
                return InputUtils.getDecimalNumberValidationRegex(this.props.locale.value);
            default:
                return InputUtils.getIntNumberValidationRegex(this.props.locale.value);
        }
    };

    formatNumber = (value: string) => {
        if (value === NEGATIVE_NUMBER_PREFIX || value === NEGATIVE_NUMBER_PREFIX + 0) {
            return "0";
        }
        return Utils.numberFormatByLocale(value, this.props.locale.value);
    };

    onChange = (e) => {
        const inputValue = e.target.value;
        let value = inputValue;
        if (this.props.handleNegativeNumbers) {
            value = this.getNumberModule(value);
        }
        if (value === '' || this.state.regex.test(value)) {
            this.setState({
                value: inputValue
            })
        }
    }

    getNumberModule = (number: string) => {
        return number.charAt(0) === NEGATIVE_NUMBER_PREFIX ? number.slice(1) : number;
    };

    handleBlur = (e) => {
        this.setState({
            value: this.formatNumber(this.state.value)
        });
        const validNumber = Utils.reverseFormattedNumber(e.target.value, this.props.locale.value);
        if (!isNaN(validNumber))
            this.props.onChange(validNumber);
        else {
            this.props.onChange("");
        }
    };

    render() {
        return (
            <input
                autoFocus
                value={this.state.value}
                onChange={this.onChange}
                onBlur={this.handleBlur}
                className={this.props.classNameStyle}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.auth.locale
    }
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(NumberInput);


// WEBPACK FOOTER //
// ./app/components/common/Input/NumberInput.tsx